import * as React from "react";
import {
  Dialog,
  TextField,
  DialogContent,
  DialogTitle,
  DialogActions,
  IconButton, Box, Button
} from "@mui/material";
import { Close } from "@mui/icons-material"
import {ChangeEvent, useEffect, useState} from "react";

export interface NewBackGroupDialogProps {
  open: boolean;
  onClose: () => void;
  handleUploadImage: (newImage) => void;
  newImage: {
    attributes: {
      FileName: string;
      Data: string;
    }
  };
}

export default function NewBackGroupDialog(props: NewBackGroupDialogProps) {
  const { onClose, open, newImage, handleUploadImage } = props;
  const [fileName, setFileName] = useState("");

  useEffect(() => {
    setFileName(newImage.attributes.FileName);
  }, [newImage])

  const handleClose = () => {
    setFileName("");
    onClose();
  };

  const onChangeName = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setFileName(value);
  };

  const handleUpload = () => {
    handleUploadImage({
      attributes: {
        FileName: fileName,
        Data: newImage.attributes.Data
      }
    })
    handleClose();
  }

  return (
    <Dialog
      maxWidth="md"
      fullWidth={true}
      // scroll="paper"
      onClose={(event, reason) => {
        handleClose();
      }}
      open={open}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <strong>
            Upload new Terminal Background
          </strong>
          <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers={true}>
        <TextField
          sx={{ mb: 4 }}
          value={fileName}
          autoFocus
          size="small"
          id="search-entity"
          label="File Name"
          type="text"
          fullWidth
          variant="standard"
          onChange={onChangeName}
        />
        <img width="100%" alt={"new-background"} src={newImage.attributes.Data} />
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="primary"
          size="large"
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={handleUpload}
        >
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
}
